import React, { useContext, useMemo, useState } from "react";

type ExpandedState = "expanded" | "collapsed";
interface LayoutContext {
  sidebar: ExpandedState;
  setSidebar(next: ExpandedState): void;
  sidepanel: ExpandedState;
  setSidepanel(next: ExpandedState): void;
  openCabinetDrawers: string[];
  setOpenCabinetDrawers(next: string[]): void;
}
const defaultContext: LayoutContext = {
  sidebar: "collapsed",
  setSidebar: () => undefined,
  sidepanel: "collapsed",
  setSidepanel: () => undefined,
  openCabinetDrawers: [],
  setOpenCabinetDrawers: () => undefined,
};
export enum CabinetDrawers {
  NotificationCenter = "NOTIFICATION_CENTER",
}

export const Context = React.createContext<LayoutContext>(defaultContext);
export const LayoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [sidebar, setSidebar] = useState<ExpandedState>("collapsed");
  const [sidepanel, setSidepanel] = useState<ExpandedState>("collapsed");
  const [openCabinetDrawers, setOpenCabinetDrawers] = useState<string[]>([]);
  const segmentContext = useMemo(
    () => ({
      sidebar,
      setSidebar,
      sidepanel,
      setSidepanel,
      openCabinetDrawers,
      setOpenCabinetDrawers,
    }),
    [
      sidebar,
      setSidebar,
      sidepanel,
      setSidepanel,
      openCabinetDrawers,
      setOpenCabinetDrawers,
    ],
  );

  return <Context.Provider value={segmentContext}>{children}</Context.Provider>;
};

export const useLayout = () => useContext(Context);
